var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5da130d78b96d15de9da098b46ac39ea0974529e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["measured-quiz@measured"]={id:"5da130d78b96d15de9da098b46ac39ea0974529e"};
      